"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.knowledge.base': 'Base di Conoscenza',
    'onboarding.knowledge.title': 'Base di Conoscenza (Opzionale)',
    'onboarding.knowledge.description': 'Aggiungi voci di conoscenza per migliorare l\'expertise e le risposte del tuo avatar.',
    'onboarding.knowledge.final.step': 'Passo Finale - Caricamento Conoscenza',
    'onboarding.knowledge.label': 'Seleziona Voci di Conoscenza',
    'onboarding.knowledge.placeholder': 'Cerca e seleziona voci di conoscenza per il tuo avatar...',
    'onboarding.knowledge.skip.info': 'Puoi saltare questo passo e aggiungere voci di conoscenza più tardi se necessario.',
    'onboarding.knowledge.selected.single': 'voce di conoscenza selezionata',
    'onboarding.knowledge.selected.multiple': 'voci di conoscenza selezionate',
    'onboarding.knowledge.bonus': 'Conoscenza aggiunta',
    'onboarding.knowledge.items': 'Elementi di Conoscenza',
};
